import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ErrorRetryCard = ({ 
  title = 'Failed to load data',
  message = 'Something went wrong while loading the data. Please try again.',
  onRetry,
  icon = 'AlertCircle',
  className = ''
}) => {
  return (
    <div className={`bg-card rounded-xl p-8 shadow-wellness elevation-1 border border-error/20 ${className}`}>
      <div className="flex flex-col items-center text-center space-y-4">
        <div className="flex items-center justify-center w-16 h-16 bg-error/10 rounded-full">
          <Icon name={icon} size={32} className="text-error" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-2">{title}</h3>
          <p className="text-muted-foreground max-w-md">
            {message}
          </p>
        </div>
        {onRetry && (
          <Button
            variant="default"
            onClick={onRetry}
            iconName="RotateCcw"
            iconPosition="left"
            className="mt-2"
          >
            Try Again
          </Button>
        )}
      </div>
    </div>
  );
};

export default ErrorRetryCard;